import type { ApolloClient } from '@apollo/client';

/**
 * Drops every cached invoice tab; the mounted one is refetched in place, the rest go to the
 * network when they are next shown.
 */
export function refreshInvoiceLists(client: ApolloClient): Promise<unknown> {
  // A failed refresh must not surface as an unhandled rejection; the next one repairs it.
  return Promise.resolve(
    client.refetchQueries({
      updateCache(cache) {
        cache.evict({ id: 'ROOT_QUERY', fieldName: 'invoicesConnection' });
        cache.gc();
      }
    })
  ).catch(() => undefined);
}
